import { useCallback, useEffect, useState } from 'react';

import { beneficiariesApi } from 'domain/payments/api';

// Fetches the unfiltered total count of beneficiaries so the grid can tell apart
// "no beneficiaries at all" (show the empty placeholder) from "no rows matching the
// current search/filters" (show the no-results message).
const useFetchBeneficiariesTotal = () => {
  const [total, setTotal] = useState<number | null>(null);
  const [isBusy, setIsBusy] = useState(true);
  const [isFetched, setIsFetched] = useState(false);

  const fetchGridTotal = useCallback(async () => {
    setIsBusy(true);
    try {
      const totalCount = await beneficiariesApi.getGridTotal();
      setTotal(totalCount ?? 0);
      setIsFetched(true);
    } catch (error) {
      console.error('[ERROR]: on fetch beneficiaries grid total', error);
      setTotal(0);
      setIsFetched(true);
    } finally {
      setIsBusy(false);
    }
  }, []);

  useEffect(() => {
    fetchGridTotal().then();
  }, [fetchGridTotal]);

  return {
    beneficiariesTotal: total,
    beneficiariesTotalIsBusy: isBusy,
    beneficiariesTotalIsFetched: isFetched,
    fetchGridTotal,
  };
};

export default useFetchBeneficiariesTotal;
